export default {
	"condition.Campaign name": "Campaign name",
    "condition.Adgroup name": "Adgroup name",
    "condition.Ad name": "Ad name",
 
    "condition.Ad set name": "Ad set name",
    "condition.Placement": "Placement",
    "condition.Lifetime budget": "Lifetime budget",
    "condition.Daily budget": "Daily budget",
    "condition.Bid amount": "Bid amount",
    "condition.Billing event": "Billing event",
    "condition.Optimization goal": "Optimization goal",

    "condition.Custom": "Custom",
    "condition.Increment CPA": "Increment CPA",
    "condition.Budget": "Budget",
    "condition.Spend Percent": "Spend Percent",

    "condition.Basic Data": "Basic Data",
	"condition.Most common": "Most common",
  "condition.Spent": "Spent",
  "condition.Lifetime spent": "Lifetime spent",
  "condition.Frequency": "Frequency",
  "condition.Results": "Results",
  "condition.Cost per result": "Cost per result",
  "condition.Mobile app install": "Mobile app install",
  "condition.Cost per mobile app install": "Cost per mobile app install",
  "condition.In-app purchase ROAS": "In-app purchase ROAS",
  "condition.Website purchase ROAS": "Website purchase ROAS",
  "condition.Settings": "Settings",

  "condition.Objective": "Objective",
  "condition.Buying type": "Buying type",
  "condition.Spend cap": "Spend cap",
  "condition.Daily ratio spent": "Daily ratio spent",
  "condition.Lifetime ratio spent": "Lifetime ratio spent",
  "condition.Audience reached %": "Audience reached %",
  "condition.Website Conversions(Meta.Pixel)": "Website Conversions(Meta.Pixel)",
  "condition.All Website Conversions(Meta.Pixel)": "All Website Conversions(Meta.Pixel)",
  "condition.Adds of Payment lnfo(Meta.Pixel)": "Adds of Payment lnfo(Meta.Pixel)",
  "condition.Adds to Cart(Meta.Pixel)": "Adds to Cart(Meta.Pixel)",
  "condition.Adds to Wishlist(Meta.Pixel)": "Adds to Wishlist(Meta.Pixel)",
  "condition.Registrations Completed(Meta.Pixel)": "Registrations Completed(Meta.Pixel)",
  "condition.Checkouts Initiated(Meta.Pixel)": "Checkouts Initiated(Meta.Pixel)",
  "condition.Leads (Meta Pixel)": "Leads (Meta Pixel)",
  "condition.Purchases(Meta Pixel)": "Purchases(Meta Pixel)",
  "condition.Searches (Meta Pixel)": "Searches (Meta Pixel)",
  "condition.Content Views(Meta Pixel)": "Content Views(Meta Pixel)",
  "condition.Other Website Conversions(Meta Pixel)": "Other Website Conversions(Meta Pixel)",
  "condition.Cost per Website Conversion(Meta Pixel)": "Cost per Website Conversion(Meta Pixel)",
  "condition.Cost per Add of Payment lnfo(Meta Pixel)": "Cost per Add of Payment lnfo(Meta Pixel)",
  "condition.Cost per Add to Cart(Meta Pixel)": "Cost per Add to Cart(Meta Pixel)",
  "condition.Cost per Add to Wishlist(Meta Pixel)": "Cost per Add to Wishlist(Meta Pixel)",
  "condition.Cost per Registration Completed(Meta Pixel)": "Cost per Registration Completed(Meta Pixel)",
  "condition.Cost per Checkout Initiated(Meta Pixel)": "Cost per Checkout Initiated(Meta Pixel)",
  "condition.Cost per Lead(Meta Pixel)": "Cost per Lead(Meta Pixel)",
  "condition.Cost per Purchase(Meta Pixel)": "Cost per Purchase(Meta Pixel)",
  "condition.Cost per Search(Meta Pixel)": "Cost per Search(Meta Pixel)",
  "condition.Cost per Content(Meta Pixel)": "Cost per Content(Meta Pixel)",
  "condition.In-app events": "In-app events",
  "condition.All in-app events": "All in-app events",
  "condition.In-app achievements unlocked": "In-app achievements unlocked",
  "condition.In-app sessions": "In-app sessions",
  "condition.In-app adds of payment info": "In-app adds of payment info",
  "condition.In-app adds to cart": "In-app adds to cart",
  "condition.In-app adds to wishlist": "In-app adds to wishlist",
  "condition.In-app registrations completed": "In-app registrations completed",
  "condition.In-app content views": "In-app content views",
  "condition.In-app checkouts initiated": "In-app checkouts initiated",
  "condition.In-app levels completed": "In-app levels completed",
  "condition.In-app purchases": "In-app purchases",
  "condition.In-app ratings submitted": "In-app ratings submitted",
  "condition.In-app searches": "In-app searches",
  "condition.In-app credits spent": "In-app credits spent",
  "condition.In-app tutorials completed": "In-app tutorials completed",
  "condition.Other in-app actions": "Other in-app actions",
  "condition.Cost per in-app event": "Cost per in-app event",
  "condition.Cost per in-app achievement unlocked": "Cost per in-app achievement unlocked",
  "condition.Cost per in-app session": "Cost per in-app session",
  "condition.Cost per in-app add of payment info": "Cost per in-app add of payment info",
  "condition.Cost per in-app add to cart": "Cost per in-app add to cart",
  "condition.Cost per in-app add to wishlist": "Cost per in-app add to wishlist",
  "condition.Cost per in-app registration completed": "Cost per in-app registration completed",
  "condition.Cost per in-app content view": "Cost per in-app content view",
  "condition.Cost per in-app checkout initiated": "Cost per in-app checkout initiated",
  "condition.Cost per in-app level completed": "Cost per in-app level completed",
  "condition.Cost per in-app purchase": "Cost per in-app purchase",
  "condition.Cost per in-app rating submitted": "Cost per in-app rating submitted",
  "condition.Cost per in-app search": "Cost per in-app search",
  "condition.Cost per in-app credit spent": "Cost per in-app credit spent",
  "condition.Cost per in-app tutorial completed": "Cost per in-app tutorial completed",
  "condition.Offline conversions": "Offline conversions",
  "condition.All offline conversions": "All offline conversions",
  "condition.Offline adds of payment info": "Offline adds of payment info",
  "condition.Offline adds to cart": "Offline adds to cart",
  "condition.Offline adds to wishlist": "Offline adds to wishlist",
  "condition.Offline Registrations Completed": "Offline Registrations Completed",
  "condition.Offline checkouts Initiated": "Offline checkouts Initiated",
  "condition.Offline leads": "Offline leads",
  "condition.Other offline conversions": "Other offline conversions",
  "condition.Offline purchases": "Offline purchases",
  "condition.Offline searches": "Offline searches",
  "condition.Offline content views": "Offline content views",
  "condition.Cost per offline conversion": "Cost per offline conversion",
  "condition.Cost per offline add of payment info": "Cost per offline add of payment info",
  "condition.Cost per offline add to cart": "Cost per offline add to cart",
  "condition.Cost per offline registration completed": "Cost per offline registration completed",
  "condition.Cost per offline checkout initiated": "Cost per offline checkout initiated",
  "condition.Cost per offline lead": "Cost per offline lead",
  "condition.Cost per other offline conversion": "Cost per other offline conversion",
  "condition.Cost per offline purchase": "Cost per offline purchase",
  "condition.Cost per offline content view": "Cost per offline content view",
  "condition.Other": "Other",
  "condition.CPC (Link)": "CPC (Link)",
  "condition.Link clicks": "Link clicks",
  "condition.CPM": "CPM",
  "condition.CTR (Link)": "CTR (Link)",
  "condition.Lifetime impressions": "Lifetime impressions",
  "condition.Impressions": "Impressions",
  "condition.Reach": "Reach",
  "condition.Leads": "Leads",
  "condition.Actions": "Actions",
  "condition.Clicks": "Clicks",
  "condition.CPA": "CPA",
  "condition.CPC": "CPC",
  "condition.CPP": "CPP",
  "condition.CTR": "CTR",
  "condition.Result rate": "Result rate",
  "condition.Cost per unique click": "Cost per unique click",
  "condition.Unique clicks": "Unique clicks",
  "condition.Today spent": "Today spent",
  "condition.Yesterday spent": "Yesterday spent",
  "condition.Post engagement": "Post engagement",
  "condition.Cost per post engagement": "Cost per post engagement",
  "condition.3-Second video views": "3-Second video views",
  "condition.Cost per video vlew": "Cost per video vlew",
  "condition.Page likes": "Page likes",
  "condition.Offsite engagements": "Offsite engagements",
  "condition.Posts": "Posts",
  "condition.Post comments": "Post comments",
  "condition.Post reactions": "Post reactions",
  "condition.Content views": "Content views",
  "condition.Clicks to play video": "Clicks to play video",
  "condition.Question answers": "Question answers",
  "condition.New messaging connections": "New messaging connections",
  "condition.Cost per new messaging connection": "Cost per new messaging connection",
  "condition.Messaging replies": "Messaging replies",
  "condition.Cost per messaging reply": "Cost per messaging reply",



  "Action.Scale budget by target field": "Scale budget by target field",

  "Action.General": "General",
  "Action.Start": "Start",
  "Action.Pause": "Pause",
  "Action.Close other ads when Incr Complete Payment": "Close other ads when Incr Complete Payment",

  "Action.Budget": "Budget",
  "Action.Increase budget by $": "Increase budget by $",
  "Action.Increase budget by %": "Increase budget by %",
  "Action.Decrease budget by $": "Decrease budget by $",
  "Action.Decrease budget by %": "Decrease budget by %",
  "Action.Set new budget $": "Set new budget $",

  "Action.Bid(Conversation bid)": "Bid(Conversation bid)",
  "Action.Increase bid by $": "Increase bid by $",
  "Action.Increase bid by %": "Increase bid by %",
  "Action.Decrease bid by $": "Decrease bid by $",
  "Action.Decrease bid by %": "Decrease bid by %",
  "Action.Set new bid $": "Set new bid $",

  "condition.Facebook feeds(desktop)": "Facebook feeds(desktop)",
  "condition.Facebook feeds (mobile)": "Facebook feeds (mobile)",
  "condition.Facebook right column": "Facebook right column",
  "condition.Instagram feed": "Instagram feed",
  "condition.Instagram Stories": "Instagram Stories",
  "condition.Audience Network": "Audience Network",
  "condition.Messenger inbox": "Messenger inbox",
  "condition.Facebook Marketplace": "Facebook Marketplace",

  "condition.App Installs": "App Installs",
  "condition.Brand awareness": "Brand awareness",
  "condition.Clicks on your ad": "Clicks on your ad",
  "condition.Engaged users": "Engaged users",
  "condition.FBX usage": "FBX usage",
  "condition.Event response": "Event response",

  "condition.Offer claims": "Offer claims",
  "condition.Conversions": "Conversions",
  "condition.Page engagement": "Page engagement",
  "condition.Page Likes": "Page Likes",
  "condition.Post Engagement": "Post Engagement",
  "condition.Daily unique reach": "Daily unique reach",
  "condition.Replies": "Replies",
  "condition.Social impressions": "Social impressions",
  "condition.10-second video views": "10-second video views",
};
